import { MenuService } from '../shared/header/menu/menu.service';
import { TranslateService } from '@ngx-translate/core';
import { PageGuideService } from '../page-guide/page-guide.service';
import * as i0 from "@angular/core";
import * as i1 from "../shared/header/menu/menu.service";
import * as i2 from "../page-guide/page-guide.service";
import * as i3 from "@ngx-translate/core";
var BootstrapService = /** @class */ (function () {
    function BootstrapService(menuService, pageGuideService, translateService) {
        this.menuService = menuService;
        this.pageGuideService = pageGuideService;
        this.translateService = translateService;
    }
    BootstrapService.prototype.bootstrap = function (token) {
        this.menuService.fetchMenu(this.translateService.currentLang, token);
        this.pageGuideService.startPageGuide();
    };
    BootstrapService.ngInjectableDef = i0.defineInjectable({ factory: function BootstrapService_Factory() { return new BootstrapService(i0.inject(i1.MenuService), i0.inject(i2.PageGuideService), i0.inject(i3.TranslateService)); }, token: BootstrapService, providedIn: "root" });
    return BootstrapService;
}());
export { BootstrapService };
